import SkeletonElement from "./SkeletonElement";

/**
 * Props for TableSkeleton component
 * @param columns - Number of columns in the table (default: 4)
 * @param rows - Number of rows in the table (default: 4)
 * @param className - Additional CSS classes
 */
type TableSkeletonProps = {
  columns?: number;
  rows?: number;
  className?: string;
};

export default function TableSkeleton({ columns = 4, rows = 4, className = "" }: TableSkeletonProps) {
  return (
    <div
      className={`mt-12 border border-sys-brand-outline-variant rounded-lg overflow-hidden ${className}`}
      data-testid="table-skeleton"
    >
      <div className="bg-sys-brand-surface-container px-4 py-3">
        <div className={`grid gap-4`} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
          {Array.from({ length: columns }).map((_, index) => (
            <SkeletonElement key={index} height="h-5" width="w-20" data-testid="table-skeleton-header-cell" />
          ))}
        </div>
      </div>

      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="px-4 py-3 border-t" data-testid="table-skeleton-row">
          <div
            className={`grid gap-4 items-center`}
            style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
          >
            {Array.from({ length: columns }).map((_, colIndex) => (
              <SkeletonElement key={colIndex} height="h-4" data-testid="table-skeleton-cell" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
